var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"container mx-auto p-6 font-mono"},[_c('div',{staticClass:"w-full mb-8 overflow-hidden rounded-lg shadow-lg"},[_c('div',{staticClass:"w-full overflow-x-auto"}),_c('table-wrapper')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }